import { LegalPage } from "./legal/LegalPage";
import MarriageRewardTerms from "./dynamic/MarriageRewardTerms";
import { REWARD_TERMS_PATH } from "./home/data/reward";

export default function MarriageRewardTermsComponent() {
  return (
    <LegalPage path={REWARD_TERMS_PATH}>
      <MarriageRewardTerms />
    </LegalPage>
  );
}
